export default "__VITE_PUBLIC_ASSET__aac0195d__"